import { useContext } from "react";

import { AppDefaultInfoContext } from "helpers/globalContext/AppDefaultInfoContext";

import { BTButtonDeprecated } from "commonComponents/btWrappers/BTButtonDeprecated/BTButtonDeprecated";
import { BTCol } from "commonComponents/btWrappers/BTCol/BTCol";
import { BTExternalLink } from "commonComponents/btWrappers/BTExternalLink/BTExternalLink";
import { BTIconExternalLink } from "commonComponents/btWrappers/BTIcon";
import { BTRow } from "commonComponents/btWrappers/BTRow/BTRow";
import { BTTitle } from "commonComponents/btWrappers/BTTitle/BTTitle";
import { BTLogoDeprecated } from "commonComponents/utilities/BTLogo/BTLogoDeprecated";
import { getTakeoffUrl } from "commonComponents/utilities/MainNavigation/MainNavigation.types";

import "./TakeoffIntegrationMarketing.less";

interface ITakeoffIntegrationMarketingProps {
    title: React.ReactNode;
    details: React.ReactNode;
    onClick: () => void;
    showLearnMoreLink?: boolean;
    showConnectButton?: boolean;
}

export const TakeoffIntegrationMarketing: React.FunctionComponent<
    ITakeoffIntegrationMarketingProps
> = ({ title, details, onClick, showLearnMoreLink = true, showConnectButton = true }) => {
    const appDefaults = useContext(AppDefaultInfoContext);

    return (
        <div className="takeoffIntegrationMarketing text-center">
            <div className="IconContainer margin-vertical-lg">
                <BTLogoDeprecated />
            </div>
            <BTTitle level={1}>{title}</BTTitle>
            <BTRow className="margin-bottom-md">
                <BTCol className="text-center" md={{ span: 12, offset: 6 }}>
                    {details}
                </BTCol>
            </BTRow>
            <BTRow className="justify-content-center" gutter={8}>
                {showLearnMoreLink && (
                    <BTCol>
                        <BTExternalLink
                            buttonType="secondary"
                            data-testid="learn-more"
                            href={getTakeoffUrl(appDefaults)}
                        >
                            <BTIconExternalLink />
                            Learn More
                        </BTExternalLink>
                    </BTCol>
                )}
                {showConnectButton && (
                    <BTCol>
                        <BTButtonDeprecated type="primary" data-testid="connect" onClick={onClick}>
                            Get Started with Buildertrend Takeoff
                        </BTButtonDeprecated>
                    </BTCol>
                )}
            </BTRow>
        </div>
    );
};
